module.exports = __webpack_public_path__ + "img/ar.5b911969.svg";